import { useEffect, useRef, useState } from "react";
import Flex, { FlexProps } from "../../../shared/components/Flex";
import useDevice from "../../../shared/hooks/useDevice";

function AdaptiveFlex({ children, ...props }: FlexProps) {
    const device = useDevice();
    const isMobile = device !== "desktop";
    const [innerHeight, setInnerHeight] = useState<number | null>(null);
    const [applyHeight, setApplyHeight] = useState(false);
    const contentRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (!isMobile) return;

        const updateHeight = () => {
            const vh = window.visualViewport?.height ?? window.innerHeight;
            setInnerHeight(vh - 130);
        };

        updateHeight();
        window.visualViewport?.addEventListener("resize", updateHeight);
        window.addEventListener("resize", updateHeight);

        return () => {
            window.visualViewport?.removeEventListener("resize", updateHeight);
            window.removeEventListener("resize", updateHeight);
        };
    }, [isMobile]);
    
    // children 높이 비교 → height 적용 여부 결정
    useEffect(() => {
        if (!isMobile || innerHeight === null || !contentRef.current) return;

        const contentHeight = contentRef.current.scrollHeight;
        setApplyHeight(contentHeight > innerHeight);
    }, [children, innerHeight, isMobile]);

    return (
        <div style={{overflow: isMobile ? "auto" : "none",height: isMobile && applyHeight ? innerHeight ?? undefined : undefined }}>
            <Flex flexDirection={"column"} gap={isMobile ? 24 : 44} style={{padding: "0 20px 20px"}} ref={contentRef} {...props}>
                    {children}
            </Flex>
        </div>
  );
}

export default AdaptiveFlex;